import { React } from "react";
import './css/aboutUs.css'
import fingers from '../components/assets/branding/2fingers.png'


const AboutUs = () => {
    return (
        <div className='about-us'>
            <div className='hero'>
                <div>
                    <h2>The Most Offensive Cards On The Internet</h2>
                    <p>Home of the emotionally inept and sentimentally clumsy</p>
                </div>
                <img src={fingers} className='hand-icon' alt="" />
            </div>
            <div className='about-us-section'>
                <div className='about-us-section-inner left'>
                    <h3>Forget the love poetry and warm sentiment</h3>
                </div>
                <div className='about-us-section-inner right'>
                    <p>Bastard Cards is home to the emotionally inept and sentimentally clumsy friends, family or partners who have to say “I love you” in a different way.

                        Perhaps your best friend is getting married. The only greeting cards available are those that flaunt fluffy love poetry, wishing someone joy and happiness on their special day. Perhaps that is your genuine sentiment, deep down, but it’s not generally how you express your love.

                        Normally, when you greet a friend, you call them a “c*ck muncher” or “fat f**ker”.

                        For example, you’re the type of person that, on the best day of your best friend’s life – their wedding day – you want a card that epitomises a best man speech. Something that brings a balanced mix of both horror and joy, as they open their utterly abusive wedding card (in front of their nan).

                        We have offensive cards for every occasion, including birthdays cards, wedding cards, engagement cards, anniversary cards for your special someone (or someone else’s, we won’t judge) and more.
                    </p>
                </div>


            </div>
            <div className='about-us-section reverse'>
                <div className='about-us-section-inner left'>
                    <h3>Why do we exist?</h3>
                </div>
                <div className='about-us-section-inner right'>
                    <p>Why do we even exist? No no, we’re not not having an existential crisis and we definitely won’t be tackling the meaning of life. Go and ask a priest or philosopher about that one.

                        We exist because there’s nothing out there that speaks to friends and loved ones in the way that we at Bastard Cards communicate every day. Getting a normal greetings card on a special day might bring a small smile, but nothing brings us more joy than the type of banter that causes belly laughing and spontaneous, inane grinning at random points throughout the day. That is why we exist.

                        Our cards aren’t for everyone. I doubt very much any of our mothers would appreciate a card with a crudely-drawn, veiny cock on it. But if your friends and family love banter, there’s nothing better for them.
                    </p>
                </div>


            </div>
            <div className='about-us-section'>
                <div className='about-us-section-inner left'>
                    <h3>We do not support bullying!</h3>
                </div>
                <div className='about-us-section-inner right'>
                    <p>As we’ve mentioned, our cards are meant for friends and family who enjoy this type of humour and banter. However, we implore users of this site to act responsibly.

                        Our cards are supposed to bring laughter and joy to friends and family, not to bring pain and suffering to those who do not enjoy this type of humour.
                    </p>
                </div>


            </div>


        </div>
    )
}

export default AboutUs